import { Container, MuiThemeProvider, CssBaseline } from '@material-ui/core';
import customTheme from 'common-assets/style/custom-material-ui/customThemeFromF1';
import 'common-assets/style/custom-material-ui/customTheme';
import appStyle from 'common-assets/style/custom-material-ui/globalClassesProductWizard';
import { ChangeTitleListener } from 'common-react';
import React, { Suspense } from 'react';
import { RetirementCalculator, SavingsProduct } from 'retirement-calculator';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import RegistrationProcess from '../RegistrationProcess/RegistrationProcess';
import { SkipLinkProvider } from 'ui-components';

const CONTRIBUTION_LIMITS_FALLBACK_2026 = {
  [SavingsProduct.IKE]: 28260,
  [SavingsProduct.IKZE]: 11304,
  [SavingsProduct.PPE]: 42390,
  ikzeEntrepreneur: 16956,
};

function AppInner() {
  appStyle();

  return (
    <Container maxWidth={false}>
      <Suspense fallback="">
        <SkipLinkProvider>
          <Router basename={process.env.PUBLIC_URL}>
            <ChangeTitleListener/>
            <Switch>
              <Route exact path="/retirement-calculator">
                <RetirementCalculator
                  limitsSource={{
                    fallbackLimits: CONTRIBUTION_LIMITS_FALLBACK_2026,
                  }}
                />
              </Route>
              <Route>
                <RegistrationProcess />
              </Route>
            </Switch>
          </Router>
        </SkipLinkProvider>
      </Suspense>
    </Container>
  );
}

function App() {
  return (
    <MuiThemeProvider theme={customTheme}>
      <CssBaseline />
      <AppInner />
    </MuiThemeProvider>
  );
}

export default App;
